import React, { useState, useEffect } from "react";
import { useHistory, withRouter } from "react-router-dom";
import Header from "./Header/header";
import TokenStatsTable from "./commonComponents/tokenStatsTable";
import TopNav from "../components/commonComponents/navbarDesktop";

import { connect } from "react-redux";
import {
  setMetaMask,
  deleteMetaMask,
  Web3Object,
  Web3Connected,
} from "../redux/actions/web3action";
import { blockChainConfig } from "../constants/config";
const selectedBlockChain =
  blockChainConfig[
    sessionStorage.getItem("selectedBlockChain")
      ? sessionStorage.getItem("selectedBlockChain")
      : 0
  ];

const { networkIdTestNet, networkIdMainNet, providerUrl } = selectedBlockChain;

const Web3 = require("web3");

function Home(props) {
  return (
    <div className="gojiswap">
      <img
        alt=""
        className="position-absolute gradient goji"
        src="img/goji-gradient.svg"
      />
      <img
        alt=""
        className="position-absolute watermark goji"
        src="img/goji-watermark.svg"
      />

      <TopNav selectedTab={"gojiswap"} />

      <div className="container mt-5">
        <div className="row m-0 position-relative">
          <div className="col-sm-6 swapper-section">
            <div className="swapper position-relative">
              <button
                type="button"
                className="btn filter-btn"
                data-mdb-toggle="modal"
                data-mdb-target="#exampleModal"
              >
                <svg
                  width="34"
                  height="34"
                  viewBox="0 0 34 34"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    y="34"
                    width="34"
                    height="34"
                    rx="6"
                    transform="rotate(-90 0 34)"
                    fill="#1F1F1F"
                  />
                  <path
                    d="M10 21.5254V22.3457H19.8984V23.166H22.3594V22.3457H24V21.5254H22.3594V20.7051H19.8984V21.5254H10ZM21.5391 21.5254V22.3457H20.7188V21.5254H21.5391Z"
                    fill="white"
                  />
                  <path
                    d="M19.8984 10.834V11.6543H10V12.4746H19.8984V13.2949H22.3594V12.4746H24V11.6543H22.3594V10.834H19.8984ZM21.5391 11.6543V12.4746H20.7188V11.6543H21.5391Z"
                    fill="white"
                  />
                  <path
                    d="M10 14.9355V15.7559H16.0703V16.5762H18.5312V15.7559H24V14.9355H18.5312V14.1152H16.0703V14.9355H10ZM17.7109 14.9355V15.7559H16.8906V14.9355H17.7109Z"
                    fill="white"
                  />
                  <path
                    d="M10 18.2441V19.0645H11.467V19.8848H13.928V19.0645H24V18.2441H13.928V17.4238H11.467V18.2441H10ZM13.1077 18.2441V19.0645H12.2874V18.2441H13.1077Z"
                    fill="white"
                  />
                </svg>
              </button>
              {/* <!-- Tabs navs --> */}
              <ul
                className="nav nav-tabs mb-3 mt-sm-3 mt-5 justify-content-center"
                id="ex1"
                role="tablist"
              >
                <li className="nav-item" role="presentation">
                  <a
                    className="nav-link px-sm-4 px-3 active"
                    id="ex1-tab-1"
                    data-mdb-toggle="tab"
                    href="#ex1-tabs-1"
                    role="tab"
                    aria-controls="ex1-tabs-1"
                    aria-selected="true"
                  >
                    Swap
                  </a>
                </li>
                <li className="nav-item" role="presentation">
                  <a
                    className="nav-link px-sm-4 px-3"
                    id="ex1-tab-2"
                    data-mdb-toggle="tab"
                    href="#ex1-tabs-2"
                    role="tab"
                    aria-controls="ex1-tabs-2"
                    aria-selected="false"
                  >
                    Limit
                  </a>
                </li>
                <li className="nav-item" role="presentation">
                  <a
                    className="nav-link px-sm-4 px-3"
                    id="ex1-tab-3"
                    data-mdb-toggle="tab"
                    href="#ex1-tabs-3"
                    role="tab"
                    aria-controls="ex1-tabs-3"
                    aria-selected="false"
                  >
                    Liquidity
                  </a>
                </li>
              </ul>
              {/* <!-- Tabs navs --> */}

              {/* <!-- Tabs content --> */}
              <div className="tab-content" id="ex1-content">
                <div
                  className="tab-pane fade show active"
                  id="ex1-tabs-1"
                  role="tabpanel"
                  aria-labelledby="ex1-tab-1"
                >
                  <div className="swap-form form px-sm-5 pb-sm-5 pt-sm-4">
                    <div className="input-group">
                      <button
                        className="btn dropdown-toggle"
                        type="button"
                        data-mdb-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <img className="me-2" src="img/Hanu-input-ic.svg" />
                        <span>Hanu</span>
                      </button>
                      <ul className="dropdown-menu">
                        <li>
                          <a className="dropdown-item" href="#">
                            <img className="me-2" src="img/eth-input-ic.svg" />
                            <span>ETH</span>
                          </a>
                        </li>
                        <li>
                          <a className="dropdown-item" href="#">
                            <img
                              className="me-2"
                              src="img/usdtc-input-ic.svg"
                            />
                            <span>USDTC</span>
                          </a>
                        </li>
                      </ul>
                      <input
                        type="text"
                        className="form-control"
                        aria-label=""
                        placeholder="0.00"
                      />
                    </div>
                    <div className="input-group justify-content-center swipe-btn">
                      <a href="">
                        <svg
                          width="30"
                          height="30"
                          viewBox="0 0 30 30"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            x="0.25"
                            y="0.25"
                            width="29.5"
                            height="29.5"
                            rx="9.75"
                            fill="#1F1F1F"
                          />
                          <path
                            d="M9.66763 13.6084C10.0228 13.2549 10.5974 13.2563 10.9509 13.6115L14.1189 16.7948V11.0074C14.1189 10.5062 14.5252 10.1 15.0263 10.1C15.5275 10.1 15.9337 10.5062 15.9337 11.0074V16.7949L19.1017 13.6114C19.4553 13.2562 20.0298 13.2549 20.385 13.6084C20.7403 13.962 20.7416 14.5365 20.3881 14.8917L15.6695 19.6332C15.6692 19.6335 15.6689 19.6337 15.6686 19.634C15.3151 19.9883 14.7387 19.9894 14.384 19.634C14.3837 19.6337 14.3834 19.6335 14.3831 19.6332L9.66454 14.8918C9.3111 14.5366 9.31233 13.962 9.66763 13.6084Z"
                            fill="#8DC33F"
                          />
                          <rect
                            x="0.25"
                            y="0.25"
                            width="29.5"
                            height="29.5"
                            rx="9.75"
                            stroke="#484848"
                            stroke-width="0.5"
                          />
                        </svg>
                      </a>
                    </div>
                    <div className="input-group">
                      <button
                        className="btn dropdown-toggle"
                        type="button"
                        data-mdb-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <img className="me-2" src="img/usdtc-input-ic.svg" />
                        <span>USDTC</span>
                      </button>
                      <ul className="dropdown-menu">
                        <li>
                          <a className="dropdown-item" href="#">
                            <img className="me-2" src="img/eth-input-ic.svg" />
                            <span>ETH</span>
                          </a>
                        </li>
                        <li>
                          <a className="dropdown-item" href="#">
                            <img className="me-2" src="img/Hanu-input-ic.svg" />
                            <span>Hanu</span>
                          </a>
                        </li>
                      </ul>
                      <input
                        type="text"
                        className="form-control"
                        aria-label=""
                        placeholder="0.00"
                      />
                    </div>
                    <div className="form-btn mt-sm-5 mt-5">
                      {props.web3connected ? (
                        <button className="btn theme-btn w-100">Swap</button>
                      ) : (
                        <button className="btn theme-btn w-100">
                          Connect to wallet
                        </button>
                      )}
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="ex1-tabs-2"
                  role="tabpanel"
                  aria-labelledby="ex1-tab-2"
                >
                  <div className="limit-form form px-sm-5 pb-sm-5 pt-sm-4">
                    <div className="input-group mb-4 d-flex flex-column toggle-switch">
                      <div className="input-heading">Pay from:</div>
                      <div className="d-flex">
                        <label className="pe-2">BentoBox</label>
                        <label className="toggle-control">
                          <input type="checkbox" checked="checked" />
                          <span className="control"></span>
                        </label>
                        <label className="pe-2">Wallet</label>
                      </div>
                    </div>
                    <div className="input-group">
                      <button
                        className="btn dropdown-toggle"
                        type="button"
                        data-mdb-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <img className="me-2" src="img/Hanu-input-ic.svg" />
                        <span>Hanu</span>
                      </button>
                      <ul className="dropdown-menu">
                        <li>
                          <a className="dropdown-item" href="#">
                            <img className="me-2" src="img/eth-input-ic.svg" />
                            <span>ETH</span>
                          </a>
                        </li>
                        <li>
                          <a className="dropdown-item" href="#">
                            <img
                              className="me-2"
                              src="img/usdtc-input-ic.svg"
                            />
                            <span>USDTC</span>
                          </a>
                        </li>
                      </ul>
                      <input
                        type="text"
                        className="form-control"
                        aria-label=""
                        placeholder="0.00"
                      />
                    </div>
                    <div className="input-info">
                      <div className="row m-0 position-relative">
                        <div className="col-sm-6">
                          <label>In Bento:</label>
                          <label>0 Hanu</label>
                        </div>
                        <div className="col-sm-6">
                          <label>In Wallet:</label>
                          <label>0 Hanu</label>
                        </div>
                      </div>
                    </div>
                    <div className="input-group justify-content-center swipe-btn">
                      <a href="">
                        <svg
                          width="30"
                          height="30"
                          viewBox="0 0 30 30"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            x="0.25"
                            y="0.25"
                            width="29.5"
                            height="29.5"
                            rx="9.75"
                            fill="#1F1F1F"
                          />
                          <path
                            d="M9.66763 13.6084C10.0228 13.2549 10.5974 13.2563 10.9509 13.6115L14.1189 16.7948V11.0074C14.1189 10.5062 14.5252 10.1 15.0263 10.1C15.5275 10.1 15.9337 10.5062 15.9337 11.0074V16.7949L19.1017 13.6114C19.4553 13.2562 20.0298 13.2549 20.385 13.6084C20.7403 13.962 20.7416 14.5365 20.3881 14.8917L15.6695 19.6332C15.6692 19.6335 15.6689 19.6337 15.6686 19.634C15.3151 19.9883 14.7387 19.9894 14.384 19.634C14.3837 19.6337 14.3834 19.6335 14.3831 19.6332L9.66454 14.8918C9.3111 14.5366 9.31233 13.962 9.66763 13.6084Z"
                            fill="#8DC33F"
                          />
                          <rect
                            x="0.25"
                            y="0.25"
                            width="29.5"
                            height="29.5"
                            rx="9.75"
                            stroke="#484848"
                            stroke-width="0.5"
                          />
                        </svg>
                      </a>
                    </div>
                    <div className="input-group">
                      <button
                        className="btn dropdown-toggle"
                        type="button"
                        data-mdb-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <img className="me-2" src="img/usdtc-input-ic.svg" />
                        <span>USDTC</span>
                      </button>
                      <ul className="dropdown-menu">
                        <li>
                          <a className="dropdown-item" href="#">
                            <img className="me-2" src="img/eth-input-ic.svg" />
                            <span>ETH</span>
                          </a>
                        </li>
                        <li>
                          <a className="dropdown-item" href="#">
                            <img className="me-2" src="img/Hanu-input-ic.svg" />
                            <span>Hanu</span>
                          </a>
                        </li>
                      </ul>
                      <input
                        type="text"
                        className="form-control"
                        aria-label=""
                        placeholder="0.00"
                      />
                    </div>
                    <div className="input-info">
                      <div className="row m-0 position-relative">
                        <div className="col-sm-6">
                          <label>In Bento:</label>
                          <label>0 Hanu</label>
                        </div>
                        <div className="col-sm-6">
                          <label>In Wallet:</label>
                          <label>0 Hanu</label>
                        </div>
                      </div>
                    </div>
                    <div className="form-btn mt-4 mt-sm-5 mb-5">
                      <button className="btn theme-btn w-100">
                        {" "}
                        Limit Order Disabled
                      </button>
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="ex1-tabs-3"
                  role="tabpanel"
                  aria-labelledby="ex1-tab-3"
                >
                  <div className="swap-form form px-sm-5 pb-sm-5 pt-sm-4">
                    <div className="input-group">
                      <button
                        className="btn dropdown-toggle"
                        type="button"
                        data-mdb-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <img className="me-2" src="img/Hanu-input-ic.svg" />
                        <span>Hanu</span>
                      </button>
                      <ul className="dropdown-menu">
                        <li>
                          <a className="dropdown-item" href="#">
                            <img className="me-2" src="img/eth-input-ic.svg" />
                            <span>ETH</span>
                          </a>
                        </li>
                        <li>
                          <a className="dropdown-item" href="#">
                            <img
                              className="me-2"
                              src="img/usdtc-input-ic.svg"
                            />
                            <span>USDTC</span>
                          </a>
                        </li>
                      </ul>
                      <input
                        type="text"
                        className="form-control"
                        aria-label=""
                        placeholder="0.00"
                      />
                    </div>
                    <div className="input-group justify-content-center swipe-btn">
                      <a href="">
                        <svg
                          width="30"
                          height="30"
                          viewBox="0 0 30 30"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            x="0.25"
                            y="0.25"
                            width="29.5"
                            height="29.5"
                            rx="9.75"
                            fill="#1F1F1F"
                          />
                          <g clip-path="url(#clip0)">
                            <path
                              d="M21.3 14.3H15.7V8.69996C15.7 8.31364 15.3864 8 15 8C14.6136 8 14.3 8.31364 14.3 8.69996V14.3H8.69996C8.31364 14.3 8 14.6136 8 15C8 15.3864 8.31364 15.7 8.69996 15.7H14.3V21.3C14.3 21.6864 14.6136 22 15 22C15.3864 22 15.7 21.6864 15.7 21.3V15.7H21.3C21.6864 15.7 22 15.3864 22 15C22 14.6136 21.6864 14.3 21.3 14.3V14.3Z"
                              fill="#8DC33F"
                            />
                          </g>
                          <rect
                            x="0.25"
                            y="0.25"
                            width="29.5"
                            height="29.5"
                            rx="9.75"
                            stroke="#484848"
                            stroke-width="0.5"
                          />
                          <defs>
                            <clipPath id="clip0">
                              <rect
                                width="14"
                                height="14"
                                fill="white"
                                transform="translate(8 8)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </a>
                    </div>
                    <div className="input-group">
                      <button
                        className="btn dropdown-toggle"
                        type="button"
                        data-mdb-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <img className="me-2" src="img/usdtc-input-ic.svg" />
                        <span>USDTC</span>
                      </button>
                      <ul className="dropdown-menu">
                        <li>
                          <a className="dropdown-item" href="#">
                            <img className="me-2" src="img/eth-input-ic.svg" />
                            <span>ETH</span>
                          </a>
                        </li>
                        <li>
                          <a className="dropdown-item" href="#">
                            <img className="me-2" src="img/Hanu-input-ic.svg" />
                            <span>Hanu</span>
                          </a>
                        </li>
                      </ul>
                      <input
                        type="text"
                        className="form-control"
                        aria-label=""
                        placeholder="0.00"
                      />
                    </div>
                    <div className="form-btn mt-4 mt-sm-5">
                      <button className="btn theme-btn w-100">
                        {" "}
                        Connect to wallet
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Tabs content --> */}
            </div>
          </div>

          <div className="col-sm-6 d-flex align-items-center">
            <div className="form-desc">
              <h1 className="mb-4">
                Buy and Sell <br /> Trusted Cryptos
              </h1>
              <p className="mb-4 px-4 px-sm-0">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, <br />{" "}
                sed do eiusmod tempor incididunt ut.
              </p>
              <p className="powered-by logo">
                <span className="me-2">Powered by</span>
                <svg
                  width="100"
                  height="32"
                  viewBox="0 0 100 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    className="p"
                    d="M43.1082 18.5067C42.7043 18.8499 42.2544 19.113 41.7583 19.297C41.2612 19.4802 40.7446 19.5724 40.2078 19.5724C39.7964 19.5724 39.3997 19.5187 39.018 19.4112C38.6363 19.3051 38.2804 19.1533 37.9495 18.9572C37.6179 18.7618 37.3157 18.5277 37.0413 18.2552C36.7664 17.9828 36.5325 17.6797 36.3386 17.3471C36.1449 17.0139 35.9944 16.6555 35.8874 16.2721C35.7805 15.8887 35.7269 15.4907 35.7269 15.0793C35.7269 14.6679 35.7807 14.2721 35.8874 13.8929C35.9942 13.513 36.1448 13.1565 36.3386 12.8239C36.5325 12.4912 36.7664 12.1883 37.0413 11.9157C37.3157 11.6432 37.6179 11.4104 37.9495 11.216C38.2804 11.0228 38.6363 10.8722 39.018 10.7655C39.3997 10.6587 39.7966 10.605 40.2078 10.605C40.7448 10.605 41.2612 10.6971 41.7583 10.8804C42.2544 11.0637 42.7043 11.3275 43.1082 11.6705L42.2002 13.1843C41.9376 12.9176 41.6347 12.7093 41.2915 12.5577C40.9489 12.4059 40.5871 12.3301 40.2077 12.3301C39.8284 12.3301 39.4718 12.4029 39.1392 12.5483C38.8058 12.6942 38.5141 12.8903 38.2639 13.1388C38.014 13.3862 37.8161 13.6769 37.6709 14.0106C37.5256 14.3433 37.4527 14.6999 37.4527 15.0793C37.4527 15.4627 37.5256 15.8221 37.6709 16.1572C37.8161 16.4921 38.0142 16.7851 38.2639 17.0349C38.5141 17.2857 38.806 17.483 39.1392 17.6284C39.4718 17.7738 39.8284 17.8466 40.2077 17.8466C40.4254 17.8466 40.6379 17.8205 40.8432 17.7678C41.0498 17.7153 41.2454 17.643 41.4308 17.5496V15.0793H43.108V18.5067H43.1082Z"
                    fill="white"
                  />
                  <path
                    className="p"
                    d="M50.5378 16.0844C50.5378 16.5694 50.4508 17.0199 50.2769 17.4377C50.1031 17.8556 49.8673 18.2167 49.5691 18.5221C49.2703 18.8267 48.9196 19.0672 48.5181 19.2423C48.1166 19.4184 47.6859 19.506 47.226 19.506C46.7691 19.506 46.3408 19.4184 45.9386 19.2423C45.5371 19.0672 45.1857 18.8267 44.8852 18.5221C44.5841 18.2167 44.3478 17.8556 44.1739 17.4377C44.0005 17.0199 43.9136 16.5694 43.9136 16.0844C43.9136 15.5925 44.0005 15.1361 44.1739 14.716C44.3478 14.2964 44.5841 13.9338 44.8852 13.6292C45.1859 13.3246 45.5371 13.0853 45.9386 12.9114C46.3408 12.7386 46.7691 12.6511 47.226 12.6511C47.6859 12.6511 48.1166 12.7328 48.5181 12.8963C48.9196 13.0596 49.2703 13.2926 49.5691 13.593C49.8673 13.8937 50.1031 14.2548 50.2769 14.6774C50.4508 15.0987 50.5378 15.568 50.5378 16.0844ZM48.8727 16.0844C48.8727 15.8184 48.829 15.5772 48.7421 15.3614C48.6551 15.1455 48.5372 14.9599 48.3884 14.8041C48.2385 14.6483 48.0639 14.5292 47.8643 14.4463C47.6647 14.364 47.4517 14.3226 47.2258 14.3226C46.9987 14.3226 46.7864 14.364 46.5863 14.4463C46.3867 14.5292 46.2133 14.6481 46.0657 14.8041C45.9186 14.9599 45.8024 15.1455 45.7179 15.3614C45.6327 15.5774 45.5907 15.8184 45.5907 16.0844C45.5907 16.3346 45.6327 16.5669 45.7179 16.7813C45.8024 16.9954 45.9186 17.1804 46.0657 17.3379C46.2133 17.4955 46.3867 17.6198 46.5863 17.7104C46.7864 17.8013 46.9989 17.8469 47.2258 17.8469C47.4517 17.8469 47.6647 17.8043 47.8643 17.7198C48.0638 17.6353 48.2383 17.5161 48.3884 17.3626C48.5372 17.2091 48.6551 17.0235 48.7421 16.8053C48.829 16.5868 48.8727 16.3475 48.8727 16.0844Z"
                    fill="white"
                  />
                  <path
                    className="p"
                    d="M48.9878 21.8548V20.1899L49.9017 20.2015C50.1241 20.2015 50.3302 20.156 50.5192 20.0661C50.7092 19.9752 50.8737 19.8536 51.0126 19.702C51.1516 19.5514 51.2625 19.3763 51.3428 19.1784C51.4235 18.9805 51.4642 18.7728 51.4642 18.5545V12.8996H53.1531V18.5545H53.1415C53.1369 18.858 53.0959 19.1504 53.0166 19.4335C52.9384 19.7154 52.8264 19.9786 52.6803 20.2236C52.5357 20.4669 52.3618 20.6895 52.1599 20.8889C51.958 21.089 51.7362 21.2607 51.491 21.4036C51.2472 21.5472 50.9845 21.6581 50.7033 21.7369C50.4235 21.8157 50.1316 21.8548 49.8294 21.8548H48.9878V21.8548ZM53.4251 11.1378C53.4251 11.2913 53.3959 11.4343 53.3374 11.5673C53.2792 11.701 53.2009 11.8165 53.1018 11.9156C53.0027 12.0149 52.8859 12.0931 52.7504 12.1514C52.615 12.2103 52.4725 12.2395 52.3232 12.2395C52.1656 12.2395 52.0198 12.2103 51.8845 12.1514C51.749 12.0931 51.6311 12.0149 51.5308 11.9156C51.4293 11.8165 51.35 11.7008 51.2915 11.5673C51.2331 11.4343 51.2027 11.2913 51.2027 11.1378C51.2027 10.9877 51.2331 10.8466 51.2915 10.7106C51.35 10.5758 51.4293 10.4591 51.5308 10.3592C51.6311 10.2606 51.749 10.1823 51.8845 10.1229C52.0198 10.0644 52.1656 10.0354 52.3232 10.0354C52.4725 10.0354 52.615 10.0644 52.7504 10.1229C52.8857 10.1823 53.0025 10.2606 53.1018 10.3592C53.2009 10.459 53.2794 10.5758 53.3374 10.7106C53.3959 10.8467 53.4251 10.9879 53.4251 11.1378Z"
                    fill="white"
                  />
                  <path
                    className="p"
                    d="M56.3499 11.1378C56.3499 11.2913 56.3207 11.4343 56.2623 11.5673C56.204 11.701 56.1245 11.8165 56.023 11.9156C55.9214 12.0149 55.8036 12.0931 55.6695 12.1514C55.534 12.2103 55.3894 12.2395 55.2365 12.2395C55.0823 12.2395 54.9376 12.2103 54.8034 12.1514C54.6681 12.0931 54.5502 12.0149 54.4521 11.9156C54.3529 11.8165 54.2746 11.7008 54.2151 11.5673C54.1567 11.4343 54.1277 11.2913 54.1277 11.1378C54.1277 10.9877 54.1567 10.8466 54.2151 10.7106C54.2748 10.5758 54.3529 10.4591 54.4521 10.3592C54.55 10.2606 54.6679 10.1823 54.8034 10.1229C54.9376 10.0644 55.0823 10.0354 55.2365 10.0354C55.3894 10.0354 55.534 10.0644 55.6695 10.1229C55.8036 10.1823 55.9214 10.2606 56.023 10.3592C56.1245 10.459 56.204 10.5758 56.2623 10.7106C56.3207 10.8467 56.3499 10.9879 56.3499 11.1378ZM56.0652 19.3845H54.4009V12.8997H56.0652V19.3845Z"
                    fill="white"
                  />
                  <path
                    className="p"
                    d="M67.9027 18.494C67.4988 18.8418 67.0471 19.1078 66.5465 19.2935C66.0457 19.4796 65.5275 19.5724 64.9906 19.5724C64.5786 19.5724 64.1818 19.5187 63.8 19.4112C63.4183 19.3052 63.0612 19.1534 62.7285 18.9572C62.3959 18.7618 62.0925 18.5265 61.8183 18.2523C61.5427 17.9779 61.3081 17.674 61.112 17.3408C60.9158 17.0082 60.7654 16.6509 60.658 16.2694C60.5507 15.8877 60.4982 15.4907 60.4982 15.0793C60.4982 14.6679 60.5507 14.2699 60.658 13.887C60.7654 13.5031 60.9158 13.1447 61.112 12.8114C61.3081 12.4788 61.5427 12.1746 61.8183 11.9004C62.0925 11.626 62.3959 11.3903 62.7285 11.1948C63.0612 10.9994 63.4183 10.8476 63.8 10.7408C64.1817 10.6341 64.5786 10.5803 64.9906 10.5803C65.5275 10.5803 66.0457 10.6725 66.5465 10.8557C67.0471 11.039 67.4988 11.3068 67.9027 11.6582L66.9829 13.1715C66.7285 12.8973 66.4273 12.6871 66.0808 12.5389C65.733 12.3918 65.37 12.3183 64.9906 12.3183C64.6066 12.3183 64.2481 12.3906 63.9122 12.5365C63.5771 12.6812 63.2855 12.8785 63.0344 13.127C62.7845 13.3744 62.5861 13.6674 62.4415 14.0047C62.2956 14.3415 62.2232 14.6997 62.2232 15.0792C62.2232 15.4586 62.2956 15.815 62.4415 16.1478C62.5861 16.481 62.7847 16.7722 63.0344 17.0231C63.2853 17.273 63.5771 17.4712 63.9122 17.6161C64.2483 17.762 64.6066 17.8343 64.9906 17.8343C65.37 17.8343 65.733 17.7607 66.0808 17.6131C66.4273 17.466 66.7287 17.2554 66.9829 16.9805L67.9027 18.494Z"
                    fill="white"
                  />
                  <path
                    className="p"
                    d="M70.3853 19.3844H68.7325V12.8997H69.1316L69.6767 13.6687C69.9429 13.426 70.2464 13.2398 70.5849 13.1085C70.9245 12.9772 71.2759 12.9113 71.639 12.9113H73.098V14.5581H71.639C71.4651 14.5581 71.3016 14.5908 71.1488 14.655C70.9947 14.7204 70.8617 14.8091 70.7484 14.9222C70.6362 15.0344 70.5465 15.1679 70.4823 15.3213C70.4182 15.4748 70.3855 15.6388 70.3855 15.8115V19.3844H70.3853Z"
                    fill="white"
                  />
                  <path
                    className="p"
                    d="M75.3809 21.8548V20.1898L76.3018 20.2015C76.4628 20.2015 76.6181 20.1758 76.7675 20.1232C76.9168 20.0707 77.0545 19.9977 77.183 19.905C77.3103 19.8122 77.4213 19.7019 77.5181 19.5757C77.6151 19.4486 77.6944 19.3097 77.7549 19.1601C77.5729 19.2371 77.3886 19.3136 77.2006 19.3902C77.0126 19.467 76.8247 19.5056 76.6344 19.5056C76.234 19.5056 75.8595 19.4345 75.508 19.2931C75.1566 19.1525 74.8485 18.9511 74.5847 18.6908C74.3199 18.4305 74.112 18.1137 73.9602 17.7402C73.8097 17.3672 73.7338 16.9482 73.7338 16.4843V12.8992H75.3808V16.4843C75.3808 16.7141 75.4135 16.9144 75.4811 17.0866C75.5475 17.2575 75.6374 17.4011 75.7496 17.5161C75.8626 17.631 75.9958 17.7174 76.1464 17.7734C76.298 17.8304 76.4604 17.8584 76.6343 17.8584C76.8035 17.8584 76.9645 17.8188 77.1152 17.74C77.2669 17.6613 77.3988 17.5573 77.512 17.4283C77.6252 17.2994 77.7139 17.1528 77.7781 16.989C77.8434 16.8261 77.8749 16.6574 77.8749 16.4843V12.8992H79.5405V18.567C79.536 19.0227 79.4484 19.4505 79.2745 19.8509C79.1006 20.25 78.8636 20.5992 78.5624 20.8979C78.2615 21.1968 77.9123 21.4324 77.512 21.6063C77.1128 21.7803 76.6844 21.8666 76.2281 21.8666L75.3809 21.8548Z"
                    fill="white"
                  />
                  <path
                    className="p"
                    d="M82.4655 21.8549H80.8V12.8998H81.1991L81.8599 13.6807C82.0092 13.5396 82.1727 13.4064 82.35 13.2815C82.5274 13.1561 82.7129 13.0482 82.9044 12.9571C83.0958 12.8659 83.2952 12.7948 83.5008 12.7423C83.7063 12.6898 83.9139 12.6641 84.1241 12.6641C84.5804 12.6641 85.0088 12.7458 85.4102 12.9092C85.8129 13.0727 86.1643 13.3038 86.4642 13.6025C86.7652 13.9007 87.0024 14.2608 87.1763 14.6833C87.3489 15.1047 87.4366 15.5721 87.4366 16.0845C87.4366 16.6173 87.3489 17.097 87.1763 17.5225C87.0024 17.9492 86.7654 18.3098 86.4642 18.6061C86.1643 18.9033 85.813 19.1304 85.4102 19.2879C85.0087 19.4454 84.5804 19.5235 84.1241 19.5235C83.9793 19.5235 83.8346 19.5077 83.691 19.4757C83.5475 19.443 83.4062 19.3999 83.2672 19.3449C83.1283 19.2912 82.9906 19.2295 82.8553 19.1604C82.72 19.0921 82.5905 19.0215 82.4655 18.948V21.8549V21.8549ZM85.7769 16.0845C85.7769 15.8108 85.7336 15.5639 85.6473 15.3462C85.5609 15.128 85.4418 14.9435 85.2924 14.7918C85.1431 14.6402 84.968 14.5246 84.7661 14.4441C84.5642 14.3629 84.3505 14.3227 84.1243 14.3227C83.8977 14.3227 83.6854 14.3629 83.4858 14.4441C83.2862 14.5246 83.1111 14.64 82.9617 14.7918C82.8124 14.9436 82.6943 15.128 82.6081 15.3462C82.5204 15.5639 82.4773 15.8108 82.4773 16.0845C82.4773 16.3477 82.5204 16.587 82.6081 16.8054C82.6943 17.0236 82.8124 17.2091 82.9617 17.3627C83.1109 17.5162 83.286 17.6352 83.4858 17.7198C83.6853 17.8043 83.8977 17.8469 84.1243 17.8469C84.3507 17.8469 84.5642 17.8043 84.7661 17.7198C84.968 17.6353 85.1431 17.5162 85.2924 17.3627C85.4418 17.2091 85.5609 17.0236 85.6473 16.8054C85.7336 16.5868 85.7769 16.3476 85.7769 16.0845Z"
                    fill="white"
                  />
                  <path
                    className="p"
                    d="M91.5531 19.3845C91.1539 19.3845 90.7781 19.3085 90.4279 19.1581C90.0765 19.0063 89.7684 18.7987 89.5036 18.5335C89.2396 18.2697 89.032 17.9616 88.8802 17.6102C88.7286 17.2588 88.6526 16.8837 88.6526 16.4845V14.5581H87.8472V12.9112H88.6526V10.3201H90.2996V12.9112H92.8066V14.5581H90.2996V16.4845C90.2996 16.6577 90.3323 16.8201 90.3975 16.9717C90.4616 17.123 90.5503 17.2555 90.6635 17.368C90.7767 17.4812 90.9087 17.5711 91.0628 17.6377C91.2156 17.7043 91.3803 17.7375 91.5529 17.7375H92.8064V19.3843H91.5531V19.3845Z"
                    fill="white"
                  />
                  <path
                    className="p"
                    d="M100 16.0844C100 16.5694 99.9136 17.0199 99.7398 17.4377C99.5659 17.8556 99.3301 18.2167 99.0314 18.5221C98.7325 18.8267 98.3824 19.0672 97.9809 19.2423C97.5793 19.4184 97.1488 19.506 96.6888 19.506C96.2324 19.506 95.8029 19.4184 95.4014 19.2423C94.9999 19.0672 94.6487 18.8267 94.3486 18.5221C94.0476 18.2167 93.8092 17.8556 93.6365 17.4377C93.4626 17.0199 93.3762 16.5694 93.3762 16.0844C93.3762 15.5925 93.4626 15.1361 93.6365 14.716C93.8092 14.2964 94.0474 13.9338 94.3486 13.6292C94.6487 13.3246 94.9999 13.0853 95.4014 12.9114C95.8031 12.7386 96.2324 12.6511 96.6888 12.6511C97.1488 12.6511 97.5793 12.7328 97.9809 12.8963C98.3824 13.0596 98.7325 13.2926 99.0314 13.593C99.3301 13.8937 99.5659 14.2548 99.7398 14.6774C99.9135 15.0987 100 15.568 100 16.0844ZM98.3343 16.0844C98.3343 15.8184 98.2912 15.5772 98.2047 15.3614C98.1185 15.1455 98.0006 14.9599 97.85 14.8041C97.7017 14.6483 97.5268 14.5292 97.327 14.4463C97.1275 14.364 96.9138 14.3226 96.6887 14.3226C96.4621 14.3226 96.2486 14.364 96.049 14.4463C95.8495 14.5292 95.6755 14.6481 95.5284 14.8041C95.3812 14.9599 95.2658 15.1455 95.1806 15.3614C95.0954 15.5774 95.0535 15.8184 95.0535 16.0844C95.0535 16.3346 95.0954 16.5669 95.1806 16.7813C95.2658 16.9954 95.3812 17.1804 95.5284 17.3379C95.6755 17.4955 95.8495 17.6198 96.049 17.7104C96.2484 17.8013 96.4621 17.8469 96.6887 17.8469C96.9138 17.8469 97.1274 17.8043 97.327 17.7198C97.5266 17.6353 97.7017 17.5161 97.85 17.3626C98.0006 17.2091 98.1185 17.0235 98.2047 16.8053C98.2912 16.5868 98.3343 16.3475 98.3343 16.0844Z"
                    fill="white"
                  />
                  <path
                    d="M15.9635 0C7.16095 0 0 7.1613 0 15.9628C0 24.765 7.16095 31.9263 15.9635 31.9263C24.7659 31.9263 31.9267 24.765 31.9267 15.9628C31.9267 7.16113 24.7659 0 15.9635 0ZM17.6349 10.7883C15.2355 11.9041 13.3857 14.0084 12.6135 16.5754C11.9863 16.2814 11.4054 15.9056 10.882 15.4626C11.5994 12.954 13.2485 10.865 15.3735 9.44958C16.0385 9.00671 16.8757 8.58626 17.4594 8.42264C18.581 8.02271 19.7846 7.79336 21.0424 7.79336C21.0963 7.79336 21.1502 7.79545 21.2046 7.79579C21.9501 7.79545 22.7552 7.87248 23.5863 8.07227C23.6682 8.09226 23.7499 8.11313 23.8323 8.13539C23.8436 8.13834 23.8556 8.14112 23.8676 8.14443C24.0539 8.1952 24.2401 8.25258 24.4282 8.31709C24.4574 8.32666 24.4881 8.33796 24.5174 8.34839C24.5792 8.3703 24.6411 8.39256 24.7035 8.41586C24.8664 8.47741 25.0293 8.54383 25.1928 8.61669C25.1921 8.60052 25.1902 8.5847 25.1888 8.56887C25.1902 8.56992 25.1916 8.57026 25.1928 8.57026C25.081 7.14878 24.4801 5.77582 24.1003 5.03369C23.8092 4.50179 23.466 4.00136 23.0798 3.53866C27.3776 6.01003 30.2799 10.6468 30.2846 15.9493C28.9453 12.4306 25.5386 9.92271 21.555 9.92271C20.7844 9.92271 20.0358 10.0175 19.3191 10.1943C18.7788 10.3272 18.2146 10.5339 17.6349 10.7883ZM26.061 12.901C25.5896 14.8065 24.6096 16.5126 23.2684 17.8635C22.9958 15.4746 22.0323 13.2924 20.5835 11.5224C20.9021 11.4828 21.2266 11.4616 21.5548 11.4616C23.2331 11.4614 24.787 11.9957 26.061 12.901ZM15.9258 13.8724C16.7783 14.7674 17.4206 15.8635 17.7691 17.0835C17.1734 17.2304 16.5523 17.3099 15.9122 17.3099C15.2765 17.3099 14.6592 17.2318 14.0675 17.0878C14.4222 15.8656 15.0692 14.7676 15.9258 13.8724ZM9.67858 14.1908C8.6965 12.8867 8.11365 11.2663 8.11365 9.51166C8.11365 9.33621 8.12199 9.16268 8.13295 8.99001C9.07973 8.71372 10.0797 8.56244 11.1147 8.56244C11.958 8.56244 12.7775 8.66364 13.5648 8.84934C11.8192 10.2244 10.4605 12.0691 9.67858 14.1908ZM15.9122 1.71412C19.1162 1.71412 21.8722 3.65725 23.069 6.42665C22.4107 6.31433 21.7332 6.25416 21.0424 6.25416C18.94 6.25416 16.9619 6.79372 15.2367 7.7405C13.9484 7.27728 12.5608 7.02359 11.1147 7.02359C10.1917 7.02359 9.29274 7.12966 8.42785 7.32545C9.37603 4.08656 12.3711 1.71412 15.9122 1.71412ZM8.64573 3.65707C7.35153 5.26009 6.57445 7.29658 6.57445 9.51166C6.57445 14.6606 10.7629 18.8491 15.9122 18.8491C16.6448 18.8491 17.3561 18.762 18.0404 18.601C18.0555 18.8018 18.0663 19.0035 18.0663 19.2076C18.0663 19.7927 17.9991 20.3631 17.8753 20.9115C17.4419 20.9511 17.0237 20.9743 16.6187 20.984C16.3094 21.0118 15.9971 21.0296 15.6806 21.0296C14.0905 21.0296 12.5815 20.6797 11.2239 20.0543C9.74379 19.417 8.61477 18.5086 7.75354 17.502C6.29103 15.8863 5.31468 13.8241 5.05647 11.5468C4.8732 11.6801 4.70158 11.8161 4.53552 11.953C3.24897 12.9806 2.24029 14.3419 1.64248 15.9048C1.66352 10.7041 4.47101 6.14897 8.64573 3.65707ZM17.3535 22.4491C16.6267 24.0193 15.3909 25.3051 13.8571 26.0968C12.5568 24.8882 11.5582 23.3599 10.9947 21.6334C12.4388 22.2351 14.0216 22.5686 15.681 22.5686C16.2487 22.5686 16.8063 22.5255 17.3535 22.4491ZM2.57275 19.2078C2.57275 17.4356 3.17246 15.8002 4.17871 14.4941C5.11124 17.0645 6.88118 19.2368 9.1592 20.6783C9.60868 22.9876 10.7184 25.0626 12.2812 26.7026C11.6546 26.8671 10.9973 26.9549 10.3199 26.9549C6.04829 26.9547 2.57275 23.4797 2.57275 19.2078ZM15.9635 30.2839C13.3631 30.2839 10.9225 29.5871 8.81822 28.371C9.30734 28.4508 9.8083 28.4941 10.3199 28.4941C15.44 28.4941 19.6056 24.3283 19.6056 19.2078C19.6056 16.7576 18.6489 14.5293 17.0931 12.8684C17.6456 12.481 18.2506 12.164 18.8948 11.9293C20.1422 13.2529 21.0565 14.8924 21.5025 16.7152L21.5126 16.7051C21.5211 16.7399 21.5291 16.7766 21.5378 16.8145C21.5559 16.9117 21.5743 17.0092 21.5903 17.1054C21.6741 17.5132 21.7319 17.9296 21.7672 18.3525C21.8164 18.8065 21.8437 19.2953 21.8324 19.8065C21.835 19.8065 21.8371 19.8072 21.839 19.8072C21.835 20.0066 21.8237 20.2097 21.8071 20.4156C21.8045 20.4163 21.8025 20.417 21.7998 20.417C21.7162 21.4232 21.4674 22.4844 20.9475 23.5004C20.3651 24.8734 19.566 25.9241 18.8432 26.6762C18.822 26.6977 18.8013 26.7198 18.7806 26.7407C18.7081 26.8149 18.6376 26.8857 18.5672 26.9532C18.5479 26.9713 18.5293 26.9895 18.5107 27.0074C18.4495 27.066 18.3883 27.1225 18.3292 27.1761C18.3158 27.1884 18.3026 27.2015 18.2899 27.2128C18.2195 27.2754 18.1516 27.335 18.0857 27.3913C18.0718 27.403 18.0584 27.4143 18.0452 27.4254C17.9037 27.5447 17.7721 27.6497 17.6543 27.7395L17.6636 27.7435C17.6636 27.7435 18.284 28.0785 19.3172 28.3307C19.3198 28.3279 19.3231 28.3249 19.3257 28.323C20.0405 28.4991 20.7865 28.5965 21.555 28.5965C22.0038 28.5965 22.4446 28.563 22.8762 28.5011C20.8256 29.6367 18.4686 30.2839 15.9635 30.2839ZM21.555 27.0572C21.2273 27.0572 20.9028 27.0356 20.5849 26.9956C22.1919 25.0328 23.2025 22.5648 23.3356 19.8685C25.1905 18.376 26.6009 16.3544 27.3395 14.0355C28.5901 15.4193 29.3534 17.2513 29.3534 19.2593C29.3536 23.5592 25.8555 27.0572 21.555 27.0572Z"
                    fill="url(#paint0_linear10)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear10"
                      x1="6.76975"
                      y1="2.91978"
                      x2="25.2872"
                      y2="29.1909"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#8DC33F" />
                      <stop offset="1" stop-color="#00A7A7" />
                    </linearGradient>
                  </defs>
                </svg>
              </p>
            </div>
          </div>
        </div>
      </div>

      <TokenStatsTable></TokenStatsTable>

      {/* <!-- Filter Modal Start --> */}
      <div
        className="modal fade filter-modal"
        id="exampleModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Transaction Settings
              </h5>
              <button
                type="button"
                className="btn-close"
                data-mdb-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body px-5">
              <div className="w-100 mb-4">
                <div className="w-100">
                  <h4>Slippage tolerance</h4>
                </div>
                <div className="input-group">
                  <button
                    className="btn dropdown-toggle"
                    type="button"
                    data-mdb-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <span>Auto</span>
                  </button>
                  <input
                    type="text"
                    className="form-control"
                    aria-label=""
                    placeholder="0.10%"
                  />
                </div>
              </div>
              <div className="w-100 mb-4">
                <div className="w-100">
                  <h4>Transaction deadline (minutes)</h4>
                </div>
                <div className="input-group">
                  <button
                    className="btn dropdown-toggle"
                    type="button"
                    data-mdb-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <span>Mins</span>
                  </button>
                  <input
                    type="text"
                    className="form-control"
                    aria-label=""
                    placeholder="30"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Filter Modal End --> */}
    </div>
  );
}

const mapDispatchToProps = {
  setMetaMask,
  deleteMetaMask,
  Web3Connected,
  Web3Object,
};

const mapStateToProps = (state, ownProps) => {
  return {
    metaMaskAddress: state.web3.metaMaskAddress,
    web3connected: state.web3.web3connected,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Home));
